/**
 * Pure helpers for the AI model detail screen (plan 4 R11).
 */

/**
 * @param {Array<object>} models
 * @param {string} modelId
 */
export function findModel(models, modelId) {
  const id = String(modelId || '').trim();
  if (!id) return null;
  return (models || []).find((row) => row.id === id) || null;
}

/**
 * Stat tiles shown on the detail page - only fields the /models list already returns.
 * @param {object|null|undefined} model
 * @param {{ defaultModelId?: string|null }} [opts]
 */
export function modelDetailStats(model, opts) {
  if (!model) return [];
  const isDefault = !!(opts && opts.defaultModelId && opts.defaultModelId === model.id);
  return [
    { label: 'Queries', value: formatCount(model.queries) },
    { label: 'Tokens', value: formatCount(model.tokens) },
    { label: 'Plan limit', value: model.plan_limit_label || '- (beta)' },
    { label: 'Provider', value: model.providerName || model.provider || '-' },
    { label: 'Key source', value: model.key_source === 'byok' ? 'Your key' : 'Catalog' },
    { label: 'Org default', value: isDefault ? 'Yes' : 'No' },
  ];
}

/** @param {unknown} n */
function formatCount(n) {
  const num = Number(n || 0);
  return Number.isFinite(num) ? num.toLocaleString() : '0';
}

/**
 * Chips for enablement / catalog / BYOK state.
 * @param {object|null|undefined} model
 * @param {{ defaultModelId?: string|null }} [opts]
 */
export function modelDetailChips(model, opts) {
  if (!model) return [];
  const chips = [];
  chips.push(model.enabled ? 'On' : 'Off');
  if (opts && opts.defaultModelId && opts.defaultModelId === model.id) chips.push('Org default');
  if (model.defaultEnabled) chips.push('Catalog default');
  if (model.key_source === 'byok') chips.push('Your key');
  if (model.configured === false) chips.push('Key needed');
  return chips;
}

/**
 * @param {object|null|undefined} model
 * @param {boolean} wantEnabled
 */
export function canToggleModel(model, wantEnabled) {
  if (!wantEnabled) return { ok: true };
  if (model && model.configured === false) {
    return {
      ok: false,
      error: 'Add and test a provider API key before enabling this model',
    };
  }
  return { ok: true };
}

/** Path back to the models list, keeping product_id when present. */
export function modelsListHref(productId) {
  if (!productId) return '/app/settings/models';
  return `/app/settings/models?product_id=${encodeURIComponent(productId)}`;
}

/** Detail path for a model card. */
export function modelDetailHref(modelId, productId) {
  const base = `/app/settings/models/${encodeURIComponent(String(modelId || '').trim())}`;
  if (!productId) return base;
  return `${base}?product_id=${encodeURIComponent(productId)}`;
}
